export const CHILD_LIVING_SITUATIONS = [
    "One Parent",
    "Both Parents",
    "Guardian/Caregiver",
    "Grandparents",
    "Foster Home",
    "Group Home",
    "Other"
];

export const GRADE_LEVELS = [
    "Pre-K",
    "Kindergarten",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th"
];

export const GENDERS = [
    "Male",
    "Female",
    "Other"
];

// Child relationships for the parent creating the Family account
export const PARENT_TYPES = ["Parent", "Legal Guardian"]

// Child relationships for alternate contacts listed on account
export const FAMILY_CONTACT_TYPES = [
    "Father",
    "Mother",
    "Legal Guardian",
    "Relative",
    "Family Friend"
];

export const CONTACT_TYPES = [
    "Father",
    "Mother",
    "Legal Guardian",
    "Relative",
    "Friend"
];

export const HOUSEHOLD_RELATIONSHIPS = [
    "Parent",
    "Guardian",
    "Child"
];

export const PAYMENT_FREQUENCIES = [
    "Weekly",
    "Biweekly",
    "Monthly",
    "Annually"
]

export const ETHNICITIES = [
    "White",
    "Black",
    "Hispanic/Latino",
    "Asian",
    "Pacific Islander",
    "Native American"
];

export const US_STATES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];

export const CHILD_FORM_DEFAULTS = {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    socialSecurity: "",
    childHasSameAddressAsParent: true,
    streetAddress: "",
    city: "",
    state: "GA",
    zipcode: "",
    age: "",
    gender: "",
    ethnicity: "",
    school: "",
    gradeLevel: "",
    childID: "",
    isESOL: false,
    livingSituation: "",
    isSpecialNeeds: false,
    specialNeedsDescription: "",
    isUSCitizenOrQualifiedAlien: false,
    isGAResident: false,
    is18AndEnrolledInSchool: false,
    isAdultAndParent: false,
    inFosterCare: false,
    receivesTANF: false,
    receivesSNAP: false,
    receivesMedicaidOrSSI: false,
    receivesReducedOrFreeLunch: false,
    receivesPeachcare: false,
    hasInsuranceProvider: false,
    insuranceProviderName: "",
    hasAllergies: false,
    allergiesDescription: "",
    hasOtherMedicalConditions: false,
    otherMedicalConditionsDescription: "",
    isTakingOtherMedications: false,
    otherMedicationsDescription: "",
    hasSignedMedicalStatement: false,
    dateOfMedicalStatementSignature: ""
};
